import { queryOptions } from '@tanstack/react-query';

import { csvTableApi, type CsvTableQueryParams } from './csvTable.api';

const CSV_TABLE_QUERY_STALE_TIME_MS = 5 * 60 * 1000;

export const csvTableOptions = {
  all: () => ['csv-table'] as const,

  data: ({ fileName, groupName, queryFileId, from }: CsvTableQueryParams) =>
    queryOptions({
      queryKey: [
        ...csvTableOptions.all(),
        'data',
        groupName,
        fileName,
        queryFileId ?? null,
        from ?? null
      ] as const,
      queryFn: () => csvTableApi.data({ fileName, groupName, queryFileId, from }),
      staleTime: CSV_TABLE_QUERY_STALE_TIME_MS,
      retry: false,
      refetchOnWindowFocus: false
    })
};
